"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.delRole = delRole;
exports.getInfo = getInfo;
exports.getRoleList = getRoleList;
exports.menuCacheList = menuCacheList;
exports.updateRole = updateRole;
exports.updateRoleDataAuth = updateRoleDataAuth;
exports.updateRoleStatus = updateRoleStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增
 * @param
 */
function addRole(pram) {
  var data = {
    level: pram.level,
    roleName: pram.roleName,
    // type: pram.type,
    // createName: pram.createName,
    status: pram.status,
    rules: pram.rules
  };
  // data.rules = pram.rules.join(',')
  return (0, _requestMapi.default)({
    url: '/mapi/system/role/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param
 */
function delRole(pram) {
  var data = {
    id: pram.id
  };
  return (0, _requestMapi.default)({
    url: '/mapi/system/role/delete',
    method: 'GET',
    params: data
  });
}

/**
 * 详情
 * @param
 */
function getInfo(pram) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/role/info/".concat(pram),
    method: 'GET'
  });
}

/**
 * 分页列表
 * @param
 */
function getRoleList(pram) {
  var data = {
    createTime: pram.createTime,
    updateTime: pram.updateTime,
    level: pram.level,
    page: pram.page,
    limit: pram.limit,
    type: pram.type,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return (0, _requestMapi.default)({
    url: '/mapi/system/role/list',
    method: 'get',
    params: data
  });
}

/**
 * 修改
 * @param
 */
function updateRole(pram) {
  var data = {
    id: pram.id,
    roleName: pram.roleName,
    // type: pram.type,
    // createName: pram.createName,
    rules: pram.rules,
    status: pram.status,
    dataAuth: pram.dataAuth
  };
  return (0, _requestMapi.default)({
    url: '/mapi/system/role/update',
    method: 'post',
    params: {
      id: pram.id
    },
    data: data
  });
}

/**
 * 修改身份状态
 * @param
 */
function updateRoleStatus(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/role/updateStatus',
    method: 'get',
    params: {
      id: pram.id,
      status: pram.status
    }
  });
}
/**
 * 修改身份状态
 * @param
 */
function updateRoleDataAuth(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/role/updateRoleDataAuth',
    method: 'get',
    params: {
      id: pram.id,
      dataAuth: pram.dataAuth
    }
  });
}

/**
 * 缓存菜单
 * @param
 */
function menuCacheList(pram) {
  // return request({
  //   url: '/admin/system/menu/cache/tree',
  //   method: 'get',
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/menu/cache/tree',
    method: 'get'
  });
}